module.exports = __webpack_public_path__ + "01_short_brown.791068a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_short_brown.png
// module id = u8Zg
// module chunks = 0